import _concat from 'lodash/concat';
import _extend from 'lodash/extend';
import _union from 'lodash/union';

export interface IStyles
{
    [key:string]:string;
}

export class Styles
{
    private static RULE_PARSE_PATTERN = /(?:\s*(\S+):\s*([^;]+))/g;
    private static CAMELIFY_PATTERN = /\-([a-zA-Z0-9]{1})/g;
    private static HYPHEN_PATTERN = /[A-Z]/g;

    public static toCamelCaseStyle(str:any)
    {
        Styles.CAMELIFY_PATTERN.lastIndex = 0;
        return str.replace(Styles.CAMELIFY_PATTERN, (match:any, firstLetter:any) => firstLetter.toUpperCase(), 'g');
    }

    public static toHyphenStyle(str:any)
    {
        Styles.HYPHEN_PATTERN.lastIndex = 0;
        return str.replace(Styles.HYPHEN_PATTERN, (match:any) => `-${match.toLowerCase()}`);
    }

    public static fromCSSText(cssText:string)
    {
        const cssObject:any = {};
        let parseResult = null;

        do
        {
            parseResult = Styles.RULE_PARSE_PATTERN.exec(cssText);

            if( parseResult )
            {
                const [, property, value] = parseResult;
                const camelifiedProperty = Styles.toCamelCaseStyle(property);

                cssObject[camelifiedProperty] = value;
            }
        }
        while( parseResult !== null );

        return cssObject;
    }

    public static toCSSText(cssObject:any)
    {
        return Object.keys(cssObject)
            .map(property => `${Styles.toHyphenStyle(property)}:${cssObject[property]}`)
            .join(';');
    }

    public static unionStyles(...args:Array<IStyles>):IStyles
    {
        //Get unique classes.
        let classesNames:any = [];

        args.forEach((styleClasses) =>
        {
            if( styleClasses )
                classesNames.push(Object.keys(styleClasses));
        });

        classesNames = _union(_concat([], ...classesNames));

        //Union classes.
        const unionClasses:any = {};

        classesNames.map((className:any) =>
        {
            const classes:any = [];

            args.forEach((styleClasses) =>
            {
                if( styleClasses )
                {
                    const style = styleClasses[className];

                    if( style )
                        classes.push(style);
                }
            });

            unionClasses[className] = classes.join(' ');
        });

        return unionClasses;
    }

    public static mergeStyles(...args:Array<IStyles>):IStyles
    {
        return _extend({}, Styles.unionStyles(...args));
    }
}
